import { connectToStores } from 'fluxible-addons-react';
import { formActions } from 'mk/forms/formActions';
import FormStore from 'mk/forms/formStore';
import { RawForm } from 'mk/forms/RawForm';
import { Context } from 'mk/interfaces';
import * as React from 'react';

interface OwnProps {
    context: Context;
    className?: string;
    action: string;

    onClean?(fieldValues, fieldError, form);
    onSubmit?(formValues, form);
    onError?(formState, form);
    onSubmitSuccess?(formState, form);
    onSubmitFailure?(formState, form);
}

interface StateProps {
    formData: any;
}

type Props = OwnProps & StateProps;

class Form extends React.Component<Props> {

    private rawForm: RawForm;

    public componentDidUpdate(prevProps) {
        if (!this.props.formData.isSubmitting && prevProps.formData.isSubmitting) {
            // we were submitting and now we are not so either success submit or failure
            if (this.props.formData.submitFailed) {
                if (this.props.onSubmitFailure) {
                    this.props.onSubmitFailure(this.props.formData, this);
                }
            } else {
                if (this.props.onSubmitSuccess) {
                    this.props.onSubmitSuccess(this.props.formData, this);
                }
            }
        }
    }

    public render() {
        return (
            <RawForm
                className={this.props.className}
                onSubmit={this.onSubmit}
                onError={this.onError}
                onClean={this.props.onClean}
                fieldErrors={this.props.formData.fieldErrors}
                formErrors={this.props.formData.formErrors}
                isSubmitting={this.props.formData.isSubmitting}
                ref={(r) => this.rawForm = r}
            >
                {this.props.children}
            </RawForm>
        );
    }

    // see rawForm.getFieldRef
    public getFieldRef(name) {
        return this.rawForm.getFieldRef(name);
    }

    private onSubmit = (fieldValues) => {
        if (this.props.onSubmit) {
            this.props.onSubmit(fieldValues, this);
        }

        this.props.context.executeAction(formActions.formSubmit, {fieldValues, action: this.props.action});
    };

    /**
     * @arg {formState} data
     */
    private onError = (data) => {
        if (this.props.onError) {
            this.props.onError(data, this);
        }
        this.props.context.executeAction(formActions.formValidationError, data);
    };
}

const ConnectedForm = connectToStores(Form, [ FormStore ], (context, props) => ({
    formData: context.getStore(FormStore).getDefaultData(),
}));

ConnectedForm.prototype.getFieldRef = function(name) {
    return this.refs.wrappedElement.getFieldRef(name);
};

export {
    ConnectedForm as Form,
};
